import { mint, } from "./mint";
import { swap, } from "./swap";
import { isNativeToken, } from "./isNativeToken";
import type { AmountString, TokenIdentifier, BlockHash, } from "@bracket/types";


export declare type BuyProps = {
	tokenIn: TokenIdentifier;
	amountIn: AmountString;
  amountOut: AmountString;
  calldata?: string;
};

export declare type BuyResult = {
  hash: BlockHash;
  error: undefined;
} | {
  hash: null;
  error: Error;
};

export const buy = async ({
	tokenIn,
	amountIn,
  amountOut,
}: BuyProps): Promise<BuyResult> => {
  const native = isNativeToken(tokenIn)
  return native
    ? swap({ tokenIn, amountIn, amountOut, })
    : mint({ tokenIn, amountIn, amountOut, });
};